import { Component, Input } from '@angular/core';
import { LoaderSize } from '../loader/loader.component';

@Component({
	selector: 'cmv-loader-message',
	templateUrl: './loader-message.component.html',
	styleUrls: ['./loader-message.component.scss'],
})
export class LoaderMessageComponent {
	@Input() loaderSize: LoaderSize = 'sm';
	constructor() {}
}
